import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { AppRoutes } from '../../../constants/appRoutes';
import { InvestorStepperProvider } from '../../../context/investorStepperContext';
import { InvestorAnnouncementBar } from '../components/announcementBar';
import { RegistrationNavBar } from '../components/registrationNavBar';
import { ObjectNameFormatter } from '../../../helpers/objectNameFormatter';
import { IS_SA } from '../../../config/appConfig';

export const InvestorRegistration = () => {
	const location = useLocation();
	const { pathname, state } = location || {};
	const [isHidePlatform, setIsHidePlatform] = useState(true);
	const [welcomeBonus, setWelcomeBonus] = useState(null);
	const { settings } = useSelector(
		(state) => state.systemSettingsDataReducer
	);

	const isReg = !IS_SA && window.location.pathname.includes(`${AppRoutes.InvestorRegistration}/${AppRoutes.IRegFirstStep}`);
	const isKsaInternationalInvestor = IS_SA && !!((localStorage.getItem("isKsaInternationalInvestor") === '1') || (state && state.isKsaInternationalInvestor));

	useEffect(() => {
		setIsHidePlatform(IS_SA && pathname.includes(`${AppRoutes.InvestorRegistration}/${AppRoutes.IRegFirstStep}`));
	}, [pathname]);

	useEffect(() => {
		if (settings && settings?.enabledWelcomeBonus) {
			setWelcomeBonus(ObjectNameFormatter(JSON.parse(settings?.enabledWelcomeBonus)));
		}
	}, [settings]);

	return (
		<>
			<InvestorStepperProvider isSA={IS_SA} initialIsKsaInternationalInvestor={isKsaInternationalInvestor}>
				{!isReg ? <RegistrationNavBar marginBottom={welcomeBonus?.enabled ? 0 : 6} isShowPlatform={!isHidePlatform}></RegistrationNavBar> : null}
				{welcomeBonus?.enabled ? <InvestorAnnouncementBar welcomeBonus={welcomeBonus} /> : null}
				<Box className={`h-auto ${!isReg ? 'flex justify-center items-center' : ''}`}>
					<Box className={`${!isReg ? 'xl:w-[1140px] md:my-8 m-4' : ''} w-full h-full`}>
						<Outlet />
					</Box>
				</Box>
			</InvestorStepperProvider>
		</>
	);
};
